import {Directive, HostListener} from "@angular/core";

@Directive({selector: "[appOnlyInteger]"})
export class OnlyIntegerDirective {
	private allowedNumbers: string[] = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

	@HostListener("keypress", ["$event"])
	onKeyPress(event: KeyboardEvent) {
		if (!this.allowedNumbers.includes(event.key)) {
			event.preventDefault();
		}
	}

	@HostListener("paste", ["$event"])
	onPaste(event: ClipboardEvent) {
		const pastedText = event.clipboardData.getData("text");
		for (let pastedTextChar of pastedText) {
			if (!this.allowedNumbers.includes(pastedTextChar)) {
				event.preventDefault();
				break;
			}
		}
	}
}
